import { useEffect, useRef } from "react";
import { useToast } from "../toast/ToastProvider";

export function Alert({
  message,
  helperText,
}: {
  message: string;
  helperText?: string;
}) {
  const toast = useToast();
  const lastKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const key = `error:${message}:${helperText ?? ""}`;
    if (lastKeyRef.current === key) {
      return;
    }
    lastKeyRef.current = key;
    toast.error(message, helperText);
  }, [helperText, message, toast]);

  return null;
}
